import axios from '../../config/axiosConfig';
import { CREATE_BRANCH, GET_BRANCHES, BRANCH_REQUEST, DELETE_BRANCH, UPDATE_BRANCH, BRANCH_REQUEST_FAILURE } from '../types';
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getBranches = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BRANCH_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
              }
            return axios.get('/branch/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BRANCHES, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BRANCH_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BRANCH_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createBranch = (branch) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: BRANCH_REQUEST });

            return axios.post('/branch/add', branch,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_BRANCH, payload: response.data });
                        dispatch(addMasterInOption('branches', response.data));
                    } else {
                        dispatch({ type: BRANCH_REQUEST_FAILURE, error: 'Branch create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: BRANCH_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: BRANCH_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateBranch = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: BRANCH_REQUEST });
            return axios.put('/branch/update', { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_BRANCH, payload: { id, data: response.data } });
                    dispatch(updateMasterInOption('branches', id, response.data));
                } else {
                    dispatch({ type: BRANCH_REQUEST_FAILURE, error: 'Branch update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BRANCH_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BRANCH_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteBranch = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: BRANCH_REQUEST });
            return axios.delete(`/branch/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_BRANCH, id: id });
                    dispatch(updateMasterInOption('branches', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BRANCH_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BRANCH_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};